class TabsBlock {
  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  constructor(block, attributes = null) {
    this.block = block;
    this.container = this.block.querySelector('.tabs__container');
    this.panels = [...this.container.children];
    this.buttons = document.createElement('div');
    this.data = JSON.parse(block.dataset.tabs);

    this.buttons.className = 'tabs__buttons';

    if (this.container.firstElementChild) {
      this.container.insertBefore(this.buttons, this.container.firstElementChild);
    } else {
      this.container.appendChild(this.buttons);
    }

    this.panels.forEach((panel, i) => {
      panel.style.display = 'none';

      const button = document.createElement('button');
      button.className = 'tabs__button';
      button.textContent = this.data[i].label ?? `Tab ${i}`;
      this.buttons.appendChild(button);

      button.addEventListener('click', () => {
        [...this.buttons.children].forEach((b) => b.classList.remove('tabs__button--active'));

        this.panels.forEach((p, j) => {
          button.classList.add('tabs__button--active');

          if (i === j) {
            p.style.display = 'block';
          } else {
            p.style.display = 'none';
          }
        });
      });
    });

    if (this.buttons.children) {
      this.buttons.children[0].click();
    }
  }
}

// Initialize each block on page load (front end)
if (!window.acf) {
  document.querySelectorAll('.tabs').forEach((block) => {
    new TabsBlock(block);
  });
}